/**
 * Shared bid/offer status display helpers for profile and messaging UI.
 */

export const normalizeBidStatus = (status) => {
  if (!status) return '';
  const normalized = String(status).toLowerCase().trim();
  const statusMap = {
    'en attente': 'pending',
    'acceptée': 'accepted',
    'acceptee': 'accepted',
    'convertie': 'converted',
    'rejetée': 'rejected',
    'rejetee': 'rejected',
    'annulée': 'cancelled',
    'annulee': 'cancelled',
    'expirée': 'expired',
    'expiree': 'expired',
  };
  return statusMap[normalized] || normalized;
};

export const getBidStatusColor = (status) => {
  switch (normalizeBidStatus(status)) {
    case 'accepted':
      return 'var(--color-primary)';
    case 'converted':
      return '#3b82f6';
    case 'rejected':
    case 'cancelled':
      return '#ef4444';
    case 'expired':
      return '#f59e0b';
    case 'pending':
    default:
      return '#6b7280';
  }
};

export const getBidStatusText = (status, t) => {
  switch (normalizeBidStatus(status)) {
    case 'accepted':
      return t('offers.statusAccepted');
    case 'converted':
      return t('offers.statusConverted');
    case 'rejected':
      return t('offers.statusRejected');
    case 'cancelled':
      return t('offers.statusCancelled');
    case 'expired':
      return t('offers.statusExpired');
    case 'pending':
    default:
      return t('offers.statusPending');
  }
};

export const matchesBidFilter = (bid, filter) => {
  if (!filter || filter === 'all') return true;
  const status = normalizeBidStatus(bid.status);
  if (filter === 'pending') return status === 'pending';
  if (filter === 'accepted') return status === 'accepted' || status === 'converted';
  if (filter === 'closed') {
    return ['rejected', 'cancelled', 'expired'].includes(status);
  }
  return true;
};

export const isAcceptedBidAddable = (bid) => {
  const status = normalizeBidStatus(bid.status);
  return (
    status === 'accepted' &&
    bid.status !== 'CONVERTED' &&
    (!bid.expiresAt || new Date(bid.expiresAt) > new Date())
  );
};
